import React from "react";
import { Phone, PhoneCall, Mail, MapPin, Globe, ExternalLink } from "lucide-react";

const ContactInfo = () => {
  return (
    <div className="bg-white p-8 rounded-xl shadow-lg">
      <h2 className="text-2xl font-kufi font-bold mb-8">معلومات التواصل</h2>
      
      <div className="space-y-8">
        <div className="space-y-4">
          <h3 className="text-xl font-medium flex items-center gap-2">
            <Phone className="text-primary" />
            الهواتف الثابتة
          </h3>
          <ul className="space-y-2 pr-8">
            <li className="text-gray-700 flex items-center gap-2" dir="ltr">
              <span className="font-semibold">+966 13 864 5778</span>
              <span className="text-gray-500">المكتب الرئيسي</span>
            </li>
          </ul>
        </div>
        
        <div className="space-y-4">
          <h3 className="text-xl font-medium flex items-center gap-2">
            <PhoneCall className="text-primary" />
            أرقام الجوال
          </h3>
          <ul className="space-y-2 pr-8">
            <li className="text-gray-700 flex items-center gap-2" dir="ltr">
              <span className="font-semibold">+966 55 307 7391</span>
              <span className="text-gray-500">خدمة العملاء</span>
            </li>
            <li className="text-gray-700 flex items-center gap-2" dir="ltr">
              <span className="font-semibold">00966555738661</span>
              <span className="text-gray-500">المبيعات</span>
            </li>
          </ul>
        </div>
        
        <div className="space-y-4">
          <h3 className="text-xl font-medium flex items-center gap-2">
            <Mail className="text-primary" />
            البريد الإلكتروني
          </h3>
          <ul className="space-y-2 pr-8">
            <li className="text-gray-700">
              <a href="mailto:a-sbar@alfunoongroup.com" className="hover:text-primary">a-sbar@alfunoongroup.com</a>
              <span className="text-gray-500 mr-2">الإدارة</span>
            </li>
            <li className="text-gray-700">
              <a href="mailto:production@alfunoongroup.com" className="hover:text-primary">production@alfunoongroup.com</a>
              <span className="text-gray-500 mr-2">الإنتاج</span>
            </li>
            <li className="text-gray-700">
              <a href="mailto:ahmed-dof@alfunoongroup.com" className="hover:text-primary">ahmed-dof@alfunoongroup.com</a>
              <span className="text-gray-500 mr-2">الدعم الفني</span>
            </li>
          </ul>
        </div>
        
        <div className="space-y-4">
          <h3 className="text-xl font-medium flex items-center gap-2">
            <MapPin className="text-primary" />
            العنوان
          </h3>
          <div className="pr-8">
            <a 
              href="https://maps.app.goo.gl/n1nmemfH4UaXS3Vq6" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="inline-flex items-center gap-2 text-gray-700 hover:text-primary transition-colors group bg-gray-50 hover:bg-gray-100 px-4 py-3 rounded-lg border border-gray-200"
            >
              <div className="flex-1">
                <p className="text-right">
                  المملكة العربية السعودية<br />
                  المنطقة الشرقية، مدينة الخبر<br />
                  حي التعاون، شارع الايمان
                </p>
              </div>
              <ExternalLink className="w-5 h-5 text-primary group-hover:scale-110 transition-transform" />
            </a>
          </div>
        </div>
        
        <div className="space-y-4">
          <h3 className="text-xl font-medium flex items-center gap-2">
            <Globe className="text-primary" />
            ساعات العمل
          </h3>
          <ul className="space-y-2 pr-8">
            <li className="text-gray-700">السبت - الخميس: 7:00 صباحاً - 4:00 مساءً</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ContactInfo;
